import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Subscription } from "rxjs";
import { API } from "src/app/core/constants";
import { AppService } from "src/app/core/services/app.service";
import { CommanSubscribeService } from "src/app/core/services/comman-subscribe.service";
import { UtilityService } from "src/app/core/services/utility.service";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-community",
  templateUrl: "./community.component.html",
  styleUrls: ["./community.component.scss"],
})
export class CommunityComponent implements OnInit {
  clientDetails: any;
  selectedButton: any = "public";
  searchChannel: string = "";
  featureInfoSubscription: Subscription;
  orgIdSubscription: Subscription;
  organizationId: any;
  isBlocked: boolean = true;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  userCommunityStatusSubscription: Subscription;
  isLoading: boolean = true;
  settingsData: any = {};
  settingsDataSubscription: Subscription;
  performerInfoSubscription!: Subscription;
  org_id: any;
  private recommendationsPosted = false;
  channelName: any = "";

  constructor(
    private commanSubscribeService: CommanSubscribeService,
    private utilityService: UtilityService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router, private loader: NgxUiLoaderService, private appTVService: AppService
  ) {}

  ngOnInit(): void {

    this.settingsDataSubscription = this.commanSubscribeService.getICWebpageThemeSettings().subscribe(async (response) => {
      this.settingsData = response;
    });

    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.channelName = this.activatedRoute.snapshot.params.channelName;
    this.featureInfoSubscription = this.commanSubscribeService
      .getFeatureInfo()
      .subscribe({
        next: (featureList: any) => {
          if (
            featureList?.length > 0 &&
            !this.utilityService.isActiveFeature(featureList, "community")
          ) {
            this.toastr.warning(
              "Community feature is not accessible to this channel"
            );
            setTimeout(() => {
              this.router.navigateByUrl("/");
            }, 1500);
          }
        },
        error: (error) => {
          console.error("Error fetching feature info:", error);
          this.toastr.error("Error checking community access");
        },
      });
    this.orgIdSubscription = this.commanSubscribeService.getOrgIdInfo().subscribe((response) => {
        this.organizationId = response;
        this.getReportedUsers();
    });
    this.userInfo = this.commanSubscribeService.userInfo;
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.userCommunityStatusSubscription = this.commanSubscribeService.getUserCommunityStatus().subscribe(response => {
      this.isBlocked = response;
    });
    this.organizationId = this.commanSubscribeService.orgId;
    this.clientDetails = environment.clientDetails;
    if(this.userInfo.id){
      this.getReportedUsers();
    }
    this.performerInfoSubscription = this.commanSubscribeService.getPerfomerInfo().subscribe(response => {
      this.getPerformerSubscriptionInfo(response);
    });
  }
  getPerformerSubscriptionInfo(response: any) {
    if (response && response.data && response.data.statusCode === '200') {
      this.org_id = response.data.Data?.[0]?.organization_id ?? null;
      // this.postRecommandations();
    }
  }
  postRecommandations(){
    if (this.recommendationsPosted) return;
    this.recommendationsPosted = true;
    if (this.router.url.includes('/preview')) return;
    if (!this.org_id) {
      console.warn(
        '[Community][Recommendations] Missing required data:',
        {orgId: this.org_id}
      );
      return;
    }
    try{
          let formData = new FormData();
          formData.append('user_id', this.userInfo.id.toString());
          formData.append('organization_id', this.org_id.toString());
          formData.append('recommendation_type', 'community');
          formData.append('top_k', '40');
          if (this.commanSubscribeService.activeGroupId) {
            formData.append('network_group_id', this.commanSubscribeService.activeGroupId.toString());
          }
          let url = `${API.AI_RECOMMENDATION}?NOLOADER`;
          this.appTVService.postBaseRequest(url, formData).subscribe(result => {
            if (result.statusCode === 200) {
              // console.log("[Community][Recommendations] Recommendation success",result)
            }
          }, error => {
            console.error(
              '[Community][Recommendations] API request failed',
              {
                error,
                userId: this.userInfo.id,
                organizationId: this.commanSubscribeService?.orgId
              }
            );
          })
      
    }catch(error){
      console.error(
        '[Community][Recommendations] API request failed',
        {
          error,
          userId: this.userInfo.id,
          organizationId: this.commanSubscribeService?.orgId
        }
      );
    }
}
  goToHome() {
    const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
    this.router.navigate([base]);
  }
  getReportedUsers() {
    if (this.organizationId) {
      this.isLoading = true;
      this.loader.start();
      let URL = API.GET_REPORT_USERS;
      let payload = {
        organizationId: this.organizationId,
        userId: 'fan_' + this.userInfo.id
      }
      this.appTVService.postBaseRequest(URL, payload).subscribe(async (res) => {
        let data = res?.data?.data;
        const matchedUser = data.find((user: any) => 'fan_' + this.userInfo.id === user.userId);
        this.isBlocked = matchedUser?.isBlocked === true;
        this.isLoading = false;
        this.loader.stop();
      });
    }
  }

  onTypeSearch(event: any) {
    console.log(event);
  }

  ngOnDestroy(): void {
    if (this.featureInfoSubscription) {
      this.featureInfoSubscription.unsubscribe();
    }
    this.performerInfoSubscription?.unsubscribe();
  }
}
